module.exports = __webpack_public_path__ + "static/media/gts27.6a058f0f.png";